/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type DesignerLatestReviewQueryVariables = Types.Exact<{
    requestId: Types.Scalars['ID'];
}>;

export type DesignerLatestReviewQuery = {
    __typename: 'Query';
    request: {
        __typename: 'Request';
        collaborationListItem: Types.Maybe<{
            __typename: 'CollaborationListItem';
            latestReview: Types.Maybe<{
                __typename: 'DesignerReview';
                rating: number;
                comment: Types.Maybe<string>;
                criteria: Types.Maybe<
                    Array<{
                        __typename: 'DesignerReviewCriterion';
                        type: Types.DesignerReviewCriterionType;
                        rating: number;
                    }>
                >;
            }>;
        }>;
    };
};

export const DesignerLatestReviewDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'DesignerLatestReview' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'requestId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'request' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'requestId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'collaborationListItem' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'latestReview' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rating' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'comment',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'criteria',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'type',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'rating',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useDesignerLatestReviewQuery__
 *
 * To run a query within a React component, call `useDesignerLatestReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignerLatestReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignerLatestReviewQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useDesignerLatestReviewQuery(
    baseOptions: Apollo.QueryHookOptions<
        DesignerLatestReviewQuery,
        DesignerLatestReviewQueryVariables
    >
) {
    return Apollo.useQuery<DesignerLatestReviewQuery, DesignerLatestReviewQueryVariables>(
        DesignerLatestReviewDocument,
        baseOptions
    );
}
export function useDesignerLatestReviewLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        DesignerLatestReviewQuery,
        DesignerLatestReviewQueryVariables
    >
) {
    return Apollo.useLazyQuery<DesignerLatestReviewQuery, DesignerLatestReviewQueryVariables>(
        DesignerLatestReviewDocument,
        baseOptions
    );
}
export type DesignerLatestReviewQueryHookResult = ReturnType<typeof useDesignerLatestReviewQuery>;
export type DesignerLatestReviewLazyQueryHookResult = ReturnType<
    typeof useDesignerLatestReviewLazyQuery
>;
export type DesignerLatestReviewQueryResult = Apollo.QueryResult<
    DesignerLatestReviewQuery,
    DesignerLatestReviewQueryVariables
>;
